import { Component, effect, inject } from '@angular/core';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { TableColumn } from '../../../../modules/shared/components/kit/table/table.types';
import { routeParams, translate } from '../../../../modules/shared/shared.global-service';
import { TranslatePipe } from '@ngx-translate/core';
import { FilterBuilder } from '../../../../modules/content/helper/filter.builder';
import { VatCodeObject } from '@libs/types/src/mado/object-type/organization';
import { OrganizationSettingsVatCodeStore } from './organization-settings-vat-code.store';
import { vatCodeFrag } from './organization-settings-vat-code.query';
import { OrganizationSettingsVatCodeDialogComponent } from './dialog/organization-settings-vat-code-dialog.component';
import {
    OrganizationSettingsVatCodeLineComponent,
} from '../organization-settings-vat-code-line/organization-settings-vat-code-line.component';
import { BaseDialogService } from '../../../kit/base-dialog/base-dialog-service';
import { CheckOrCrossComponent } from '../../../kit/check-or-cross/check-or-cross.component';
import { TableComponent } from 'packages/client/src/app/modules/shared/components/kit/table/table.component';

@Component({
    selector: 'app-organization-settings-vat-code',
    templateUrl: './organization-settings-vat-code.component.html',
    providers: [OrganizationSettingsVatCodeStore],
    imports: [
        TranslatePipe,
        PrimeTemplate,
        OrganizationSettingsVatCodeLineComponent,
        CheckOrCrossComponent,
        TableComponent,
    ],
})
export class OrganizationSettingsVatCodeComponent {
    protected readonly store = inject(OrganizationSettingsVatCodeStore);
    protected readonly dialogService = inject(BaseDialogService);

    protected readonly prefix = 'organization-settings.mado.vatCode.';

    protected columns: TableColumn[] = [
        {
            name: 'name',
        },
        {
            name: 'code',
        },
        {
            name: 'amount',
        },
        {
            name: 'included',
        },
    ];

    constructor() {
        effect(() => {
            this.loadVatCodes();
        });
    }

    openDialog(vatCode: VatCodeObject | null = null) {
        const header = `${this.prefix}title` + (vatCode ? 'Detail' : 'Create');
        const dialog = this.dialogService.open(
            OrganizationSettingsVatCodeDialogComponent,
            {
                header: translate.instant(header),
                data: { vatCode },
            },
        );

        dialog?.onClose.subscribe((it) => {
            if (it === true) {
                this.loadVatCodes();
            }
        });
    }

    async loadVatCodes() {
        const organizationId = routeParams.organizationId();

        await this.store.api.getVatCodes(FilterBuilder.singlePage({ organizationId }), vatCodeFrag);
    }
}
